<template>
  <ul>
    <li><i class="circle-arrow"></i></li>
    <li>Peter Parker (SPIDERMAN) <span>23/06/16 15h08</span></li>
    <li>Bonjour, je voudrais savoir si mon avenant à bien été pris en compte dans mon contrat</li>
  </ul>
</template>

<style lang="scss" scoped>
  ul {
    padding: 0 0 7px 30px;
    border-bottom: 1px solid #ddd;
    position:relative;
    overflow:hidden;
    text-overflow: ellipsis;
    li {
      line-height: 1rem;
      font-weight: 600;
      font-size:12px;
      &:first-child {
        position:absolute;
        left:0;
        top:5px;
      }
      &:nth-child(2) {
        display:flex;
        justify-content: space-between;
        span {
          color: #666;
          font-weight:400;
          font-size:12px;
        }
      }
      &:last-child {
        color: #999;
        font-weight:400;
        overflow:hidden;
        text-overflow: ellipsis !important;
        white-space: nowrap;
        font-size:12px;
      }
    }
  }
</style>

<script type="text/babel">

  export default {

    name: "MessengerItem",

    data() {
      return {}
    },
  }
</script>




// WEBPACK FOOTER //
// client/components/Dashboard/Messenger/MessengerItem.vue